export type BlogFilterKey =
  | "all"
  | "article"
  | "dao_action"
  | "statement"
  | "approved_statement";

export interface BlogFilterOption {
  key: BlogFilterKey;
  /** Catalog sub-key under `blog.filters.*` — resolve via `t(\`filters.${labelKey}\`)` */
  labelKey: BlogFilterKey;
}

export const BLOG_FILTERS: BlogFilterOption[] = [
  { key: "all", labelKey: "all" },
  { key: "article", labelKey: "article" },
  { key: "dao_action", labelKey: "dao_action" },
  { key: "statement", labelKey: "statement" },
  { key: "approved_statement", labelKey: "approved_statement" },
];

export interface BlogQueryParams {
  category?: "article" | "dao_action" | "statement";
  status?: "executed";
}

export function filterToQuery(key: BlogFilterKey): BlogQueryParams {
  switch (key) {
    case "article":
      return { category: "article" };
    case "dao_action":
      return { category: "dao_action" };
    case "statement":
      return { category: "statement" };
    case "approved_statement":
      return { category: "statement", status: "executed" };
    default:
      return {};
  }
}

export function queryToFilterKey(params: BlogQueryParams): BlogFilterKey {
  if (params.category === "statement" && params.status === "executed")
    return "approved_statement";
  if (params.category === "statement") return "statement";
  if (params.category === "dao_action") return "dao_action";
  if (params.category === "article") return "article";
  return "all";
}
